<div class="segment-wrapper select-mode" [ngClass]="{
    'expanded': isExpanded,
    'selected': status === 'selected',
    'disabled': status === 'disabled'
  }"
  (click)="onUniversalMediaListClick()">

  <div class="segment cursor-pointer">
    <div class="seg-name-id overflow-y-hidden" [ngClass]="{'padding-bottom-1': isExpanded}">
      <div class="text-content">
        <span class="seg-id margin-right-small">[{{universalMediaList.id || 'NEW'}}]</span>
        <nz-tag *ngIf="universalMediaList.status === 'INACTIVE'"
          class="inactive-status-ligher margin-right-small bold-font">
          <span>Inactive</span>
        </nz-tag>
      </div>
      <div class="seg-name-expand-btn cursor-pointer" appShowIfTextLeaked
        [nz-tooltip]="isExpanded ? 'Shrink' : 'Expand'"
        (click)="$event.stopPropagation(); toggleExpansion()">
        <fa-icon icon="chevron-down"
          [rotate]="isExpanded ? 180 : null"
          class="font-icon-color-darker background-white"></fa-icon>
      </div>
    </div>

    <div class="seg-extra overflow-y-hidden display-flex align-items-center">
      <span>{{universalMediaList.name}}</span>
    </div>
    <div class="seg-provider overflow-y-hidden display-flex align-items-center">
      <ng-container>
        <div class="display-flex align-items-center">
          <span>{{ getUniversalMediaListMediaTypeNameDisplay() }}</span>
        </div>
      </ng-container>
    </div>
    <div class="seg-cpm overflow-y-hidden display-flex justify-content-space-between align-items-center">
      <ng-container>
        <div class="display-flex align-items-center status-view-container">
          <span>{{ getUniversalMediaListStatusDisplay() }}</span>
        </div>
      </ng-container>
      <span *ngIf="shouldShowViewButton() && status !== 'disabled'"
        class="bold-font cursor-pointer margin-left-small view-button"
        (click)="onViewMedia($event)">
        View
      </span>
    </div>
    <div class="seg-targeting-type justify-self-center align-self-end font-icon-color-mid-dark small-font text-center align-items-center">
      <div class="seg-already-added" *ngIf="status === 'disabled'">Selected</div>
    </div>
  </div>
</div>
